
import productMixin from '~/mixins/productMixin'
export default {
  name: 'RPHProductPage',
  components: {
    ProductPage: () => import('rph/templates/RPHProduct/index.vue'),
    AdultAccessModal: () => import('rph/molecules/RPHModals/RPHAdultAccessModal'),
  },
  layout: 'main',
  mixins: [productMixin],
}
